import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/activity';


// CREATE
function create(state, action) {
  state.create.result = action.payload.result ? action.payload.result:false;
}

function conexionCreate(state, action) {
  state.create.connection= action.payload.connection;
}

function errorCreate(state, action) {
  state.create.error= action.payload.error ? action.payload.error:false;
  state.create.message= action.payload.message ? action.payload.message:"";
}

function createReset(state, action) {
  state.create.result=false;
  state.create.connection= false;
  state.create.error= false;
  state.create.message= "";
}


/**
 * Conexión
 */
const activityReducer = createSlice({
  name: 'activity',
  initialState: initState,
  reducers: {
    // CREATE
    create,
    conexionCreate,
    errorCreate,
    createReset,
    
  },
});

export const activityActions = {
  ...activityReducer.actions,
};

export default activityReducer.reducer;
